import React from 'react';
import { Link } from 'react-router-dom';

const HomePage = () => {
  return (
    <>
      {/* Hero Section */}
      <section className="relative py-20 md:py-32 overflow-hidden bg-cover bg-center min-h-[80vh] flex items-center hero-section">
        {/* Content */}
        <div className="relative z-10 container mx-auto px-6 md:px-16 lg:px-8">
          <div className="px-8 text-center md:text-center md:mx-auto lg:max-w-auto lg:ml-[40%] mt-[3vw] lg:text-left">
            <h1 className="text-[30px] md:text-[51px] lg:text-[3vw] leading-tight mb-6 text-white animate-fade-in-down text-nowrap font-normal">
              Turn Time into Stars:
              <p>Map Your Cherished Moment</p>
            </h1>
            <p className="text-[16px] md:text-[20px] lg:text-[1vw] mb-0 leading-relaxed text-gray-200 animate-fade-in-up lg:text-nowrap">
              Create a personalized star map based on the exact night sky from any date and location.</p>
            <p className="text-[16px] md:text-[20px] lg:text-[1vw] mb-8 leading-relaxed text-gray-200 animate-fade-in-up">
              Whether it's a special moment or a meaningful place, capture the stars as they appeared at that very time, and turn it into a unique piece of art.
            </p>
          </div>
        </div>
      </section>

      {/* What is InterstellarMap? */}
      <section className="py-16 md:py-24 bg-black relative min-h-[200vh] overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-[50px] bg-gradient-to-b from-black/60 to-transparent z-10"></div>
        <img src="/images/gradients/gradient-1.svg" alt="Gradient" className="absolute top-[-100px] md:top-[-160px] right-[-60px] w-[400px] md:w-[815px] h-auto z-[5] opacity-70" />
        <img src="/images/gradients/gradient-2.svg" alt="Gradient" className="absolute md:top-[-220px] left-[-30px] w-[300px] md:w-[688px] h-auto z-[5] opacity-50" />
        <div className="container mx-auto px-8 lg:px-8 flex flex-col items-center relative z-10">
          <h2 className="text-center text-[30px] md:text-[51px] md:mb-8 text-white font-normal">What Is a Star Map?</h2>
          <p className="text-center text-[16px] md:text-[20px] mb-12 max-w-[1050px] mx-auto">
            A star map captures the unique alignment of stars, planets, and constellations in the sky above a specific location on a meaningful date. Whether it's the night you met someone special, the birth of your child, or the moment you said "I do" — the stars above created a pattern that's unique and unrepeatable.
            <br /><br />Now you can turn that moment into a beautiful piece of art.
          </p>
          <Link to="/create" className="button-new">
            Create Your Star Map
          </Link>
        </div>

        <div className="mx-auto px-6 lg:px-8 flex flex-col items-center !mb-[120px] w-full">
          <h2 className="text-center text-[30px] md:text-[51px] mt-[120px] mb-8 text-white font-normal relative z-10">How It Works</h2>
          <p className="text-center text-[16px] md:text-[20px] mb-12 max-w-[1050px] mx-auto relative z-10">Creating your personalized star map is simple and quick.</p>
          <div className="grid !grid-cols-1 md:!grid-cols-3 gap-4 w-full">
            <div className="flex flex-col items-center col-span-1">
              <img src="/images/star-icon-1.svg" class="w-[300px] h-[300px]"></img>
              <p className="text-center text-[16px] md:text-[20px] mb-12 mt-4 max-w-[320px] mx-auto relative z-10">Choose a date & location</p>
            </div>
            <div className="flex flex-col items-center col-span-1">
              <img src="/images/star-icon-2.svg" class="w-[300px] h-[300px]"></img>
              <p className="text-center text-[16px] md:text-[20px] mb-12 mt-4 max-w-[320px] mx-auto relative z-10">Customize your design</p>
            </div>
            <div className="flex flex-col items-center col-span-1">
              <img src="/images/star-icon-3.svg" class="w-[300px] h-[300px]"></img>
              <p className="text-center text-[16px] md:text-[20px] mb-12 mt-4 max-w-[320px] mx-auto relative z-10">We print and ship it</p>
            </div>
          </div>
        </div>

        <div className="mx-auto px-6 lg:px-16 flex flex-col items-center relative z-10 w-full">
          <h2 className="text-center text-[30px] md:text-[51px] mb-6 text-white font-normal max-w-[620px] mx-auto">
            Moments That Deserve <br />To Be Written in the Stars
          </h2>
          <p className="text-center text-[16px] md:text-[20px] mb-12 max-w-[720px] mx-auto">
            Some memories are too special to fade. Celebrate life's most meaningful milestones with a star map that captures the sky as it was on your unforgettable day.
          </p>
          <div className="grid !grid-cols-2 md:!grid-cols-4 gap-8 w-full">
            <div className="flex flex-col items-center mb-6">
              <img src="/images/home-product-1.png" className="w-full"></img>
              <p className="text-[16px] md:text-[20px] mb-1 mt-4 w-full mx-auto text-left">Anniversaries</p>
              <p className="text-[12px] md:text-[16px] w-full mx-auto text-left text-[#A0A0A0] pr-[10%]">The night your story truly began</p>
            </div>

            <div className="flex flex-col items-center mb-6">
              <img src="/images/home-product-2.png" className="w-full"></img>
              <p className="text-[16px] md:text-[20px] mb-1 mt-4 w-full mx-auto text-left">Birthdays</p>
              <p className="text-[12px] md:text-[16px] w-full mx-auto text-left text-[#A0A0A0] pr-[10%]">A snapshot of the stars from the day you came into the world</p>
            </div>

            <div className="flex flex-col items-center mb-6">
              <img src="/images/home-product-3.png" className="w-full"></img>
              <p className="text-[16px] md:text-[20px] mb-1 mt-4 w-full mx-auto text-left">Wedding</p>
              <p className="text-[12px] md:text-[16px] w-full mx-auto text-left text-[#A0A0A0] pr-[10%]">Say "I do" under the stars that witnessed your love.</p>
            </div>

            <div className="flex flex-col items-center mb-6">
              <img src="/images/home-product-4.png" className="w-full"></img>
              <p className="text-[16px] md:text-[20px] mb-1 mt-4 w-full mx-auto text-left">First Dates</p>
              <p className="text-[12px] md:text-[16px] w-full mx-auto text-left text-[#A0A0A0] pr-[10%]">Relive the magic of your very first night together.</p>
            </div>

            <div className="flex flex-col items-center mb-6">
              <img src="/images/home-product-5.png" className="w-full"></img>
              <p className="text-[16px] md:text-[20px] mb-1 mt-4 w-full mx-auto text-left">Baby Births</p>
              <p className="text-[12px] md:text-[16px] w-full mx-auto text-left text-[#A0A0A0] pr-[10%]">Welcome a new life with the sky that greeted them.</p>
            </div>

            <div className="flex flex-col items-center mb-6">
              <img src="/images/home-product-6.png" className="w-full"></img>
              <p className="text-[16px] md:text-[20px] mb-1 mt-4 w-full mx-auto text-left">Graduations</p>
              <p className="text-[12px] md:text-[16px] w-full mx-auto text-left text-[#A0A0A0] pr-[10%]">Mark a new beginning under the stars of achievement.</p>
            </div>

            <div className="flex flex-col items-center mb-6">
              <img src="/images/home-product-7.png" className="w-full"></img>
              <p className="text-[16px] md:text-[20px] mb-1 mt-4 w-full mx-auto text-left">Pet Birthdays</p>
              <p className="text-[12px] md:text-[16px] w-full mx-auto text-left text-[#A0A0A0] pr-[10%]">Celebrate your pet's special day with a star map of the sky on that unforgettable day.</p>
            </div>

            <div className="flex flex-col items-center mb-6">
              <img src="/images/home-product-8.png" className="w-full"></img>
              <p className="text-[16px] md:text-[20px] mb-1 mt-4 w-full mx-auto text-left">Personal Achievements</p>
              <p className="text-[12px] md:text-[16px] w-full mx-auto text-left text-[#A0A0A0] pr-[10%]">Mark your greatest accomplishments under the stars that witnessed your triumph.</p>
            </div>
          </div>

          <div className="flex justify-center items-center mt-8 w-full mx-auto relative z-10">
            <Link to="/create" className="button-new">
              Create Your Star Map
            </Link>
          </div>

          <div className="flex flex-col justify-center items-center mt-[160px] w-full mx-auto relative">
            <img src="/images/gradients/gradient-3.svg" alt="Gradient" className="absolute top-[620px] md:top-[-20px] left-[-90px] w-[388px] md:w-[688px] h-auto z-[5] opacity-50" />
            <img src="/images/gradients/gradient-4.svg" alt="Gradient" className="absolute bottom-[-340px] right-[-160px] w-[688px] h-auto z-[5] opacity-50" />

            <h2 className="text-center text-[30px] md:text-[51px] text-white font-normal max-w-[620px] mx-auto mb-16 -mt-12 md:-mt-0 relative z-10">Each map includes:</h2>
            <div className="grid !grid-cols-1 lg:!grid-cols-2 !gap-[20px] sm:grid-cols-1 w-full relative z-10">
              <div className="flex flex-col md:flex-row gap-4 items-center justify-start w-full max-w-[540px] mx-auto mb-8 md:mb-0">
                <img src="/images/check.svg" class="w-[30px] h-[30px] md:w-[45px] md:h-[45px]"></img>
                <p className="text-[16px] md:text-[20px] w-full text-center md:text-left">The night sky exactly as it appeared above you on your special day</p>
              </div>

              <div className="flex flex-col md:flex-row gap-4 items-center justify-start w-full max-w-[540px] mx-auto mb-8 md:mb-0">
                <img src="/images/check.svg" class="w-[30px] h-[30px] md:w-[45px] md:h-[45px]"></img>
                <p className="text-[16px] md:text-[20px] w-full text-center md:text-left">The location where it all happened (or will happen)</p>
              </div>

              <div className="flex flex-col md:flex-row gap-4 items-center justify-start w-full max-w-[540px] mx-auto mb-8 md:mb-0">
                <img src="/images/check.svg" class="w-[30px] h-[30px] md:w-[45px] md:h-[45px]"></img>
                <p className="text-[16px] md:text-[20px] w-full text-center md:text-left">A personal message or a favorite quote</p>
              </div>

              <div className="flex flex-col md:flex-row gap-4 items-center justify-start w-full max-w-[540px] mx-auto mb-8 md:mb-0">
                <img src="/images/check.svg" class="w-[30px] h-[30px] md:w-[45px] md:h-[45px]"></img>
                <p className="text-[16px] md:text-[20px] w-full text-center md:text-left">The coordinates of that place on Earth</p>
              </div>

              <div className="flex flex-col md:flex-row gap-4 items-center justify-start w-full max-w-[540px] mx-auto mb-8 md:mb-0">
                <img src="/images/check.svg" class="w-[30px] h-[30px] md:w-[45px] md:h-[45px]"></img>
                <p className="text-[16px] md:text-[20px] w-full text-center md:text-left">The date & time of your unforgettable moment</p>
              </div>

              <div className="flex flex-col md:flex-row gap-4 items-center justify-start w-full max-w-[540px] mx-auto mb-8 md:mb-0">
                <img src="/images/check.svg" class="w-[30px] h-[30px] md:w-[45px] md:h-[45px]"></img>
                <p className="text-[16px] md:text-[20px] w-full text-center md:text-left">Your chosen art style and color scheme</p>
              </div>
            </div>

            <div className="w-full bg-black relative px-8 z-10 rounded-xl mt-[100px] md:pl-[60px] md:pt-10 pb-[60px] md:pt-0 md:pr-[120px] max-w-[1480px] mx-auto">
              <h2 className='text-white text-[30px] md:text-[51px] font-normal mx-auto relative z-10 w-full text-center mt-[15%] md:mt-[5%]'>Give the Gift of a Memorable Moment</h2>
              <p className='text-lg md:text-lg font-normal mx-auto relative z-10 w-full text-center mt-4 mb-10 text-[#A961ED]'>with Our Gift Card</p>
              <div className="grid !grid-cols-1 md:!grid-cols-2 !gap-[20px] sm:grid-cols-1 w-full">
                <div className="w-full flex justify-center items-center">
                  <img src="/images/gift-card-big.svg" class="w-full h-auto"></img>
                </div>
                <div className="w-full md:pl-[10%] flex flex-col justify-center items-start">
                  <p className="text-[16px] md:text-[20px] text-center md:text-left max-w-[620px]">
                    Gift card for creating a personalized star map! It's a unique and heartfelt way to capture an important moment in your loved one's life — a birthday, anniversary, or any special event. Make your gift more than just an item, but an unforgettable experience that will stay with them forever.
                    <br /><br />Choose the amount, and let them create their own starry memory!
                  </p>
                  <Link to="/gift-card" className="button-new mt-10 mx-auto md:mx-0">
                    Buy Gift Card
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="w-full flex flex-col justify-center items-center mt-[40px] max-w-[1180px] mx-auto relative z-10 px-8">
          <h2 className="text-white text-[30px] md:text-[51px] font-normal relative z-10 w-full text-center mt-[10%]">
            You Asked, The Stars Answered
          </h2>
          <div className="w-full flex flex-col justify-center items-center mt-4 md:mt-10">
            <h3 className="text-[#A961ED] text-[26px] md:text-[35px] font-normal relative z-10 w-full text-left mt-4">
              How do you get the star data?
            </h3>
            <p className="text-[16px] md:text-[20px] text-left">
              A star map captures the unique alignment of stars, planets, and constellations in the sky above a specific location on a meaningful date. Whether it's the night you met someone special, the birth of your child, or the moment you said "I do" — the stars above created a pattern that's unique and unrepeatable.
            </p>
          </div>
          <div className="grid !grid-cols-1 md:!grid-cols-2 !gap-6 w-full mt-10">
            <div className="w-full">
              <p className='text-xl w-full text-[#A961ED]'>Hipparcos Catalog</p>
              <p className='text-md w-full mt-1'>a high-precision astrometric catalog with star positions accurate to within 1 milliarcsecond</p>
            </div>

            <div className="w-full">
              <p className='text-xl w-full text-[#A961ED]'>Proper Motion Calculations</p>
              <p className='text-md w-full mt-1'>star positions are adjusted for the exact date using proper motion data, ensuring long-term accuracy</p>
            </div>

            <div className="w-full">
              <p className='text-xl w-full text-[#A961ED]'>IAU Standards</p>
              <p className='text-md w-full mt-1'>we follow the official constellation boundaries defined by the International Astronomical Union</p>
            </div>

            <div className="w-full">
              <p className='text-xl w-full text-[#A961ED]'>Keplerian Elements</p>
              <p className='text-md w-full mt-1'>for planets, we use the same orbital mechanics trusted by astronomers to calculate their positions on any specific date</p>
            </div>
          </div>

          <p className="text-md text-left mt-10 w-full">In short: your star map reflects the real night sky, just as it was — or will be — at your meaningful moment.</p>

          <div className="w-full flex flex-col justify-center items-center mt-20 mb-10 max-w-[1180px] mx-auto">
            <div
              className="w-full py-10 md:py-20"
              style={{
                border: '1px solid',
                borderImageSource: 'linear-gradient(90deg, #000000 0%, #7A7A7F 52.4%, #000000 100%)',
                borderImageSlice: '1',
              }}
            >
              <h3 className="text-[#A961ED] text-[26px] md:text-[35px] font-normal relative z-10 w-full text-left">Can I choose any date and location?</h3>
              <p className="text-[16px] md:text-[20px] text-left md:max-w-[80%]">
                Absolutely! You can pick any moment in time — past, present, or future — and any place on Earth, from your hometown to a hidden beach where something magical happened.                  </p>
            </div>

            <div
              className="w-full py-20"
              style={{
                border: '1px solid',
                borderImageSource: 'linear-gradient(90deg, #000000 0%, #7A7A7F 52.4%, #000000 100%)',
                borderImageSlice: '1',
              }}
            >
              <h3 className="text-[#A961ED] text-[26px] md:text-[35px] font-normal relative z-10 w-full text-left">Do you ship worldwide?</h3>
              <p className="text-[16px] md:text-[20px] text-left md:max-w-[80%]">
                Yes! We offer free worldwide shipping to most countries. No matter where you are, your stars can find their way to you.
              </p>
            </div>

            <div
              className="w-full pt-10 md:pt-20"
              style={{
                borderTop: '1px solid',
                borderImageSource: 'linear-gradient(90deg, #000000 0%, #7A7A7F 52.4%, #000000 100%)',
                borderImageSlice: '1',
              }}
            >
              <h3 className="text-[#A961ED] text-[26px] md:text-[35px] font-normal relative z-10 w-full text-left">What's the delivery time?</h3>
              <p className="text-[16px] md:text-[20px] text-left md:max-w-[80%]">
                We typically process and ship orders within 2–5 business days. Delivery time depends on your location, but most orders arrive within 5–14 business days. Express options are also available at checkout.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HomePage; 